module.exports = __WEBPACK_EXTERNAL_MODULE__mui_material_Paper__;